import { useSelector } from 'react-redux';
import { DialogContentText, Typography } from '@mui/material';

import { dialogPropsSelector } from 'store/entities/ui/slice';
import { Dialog } from 'components/complex';

const id = 'confirmation-dialog';

export const ConfirmationDialog = () => {
  const props = useSelector(dialogPropsSelector);

  const { dialogTitle, contentText, warningText, confirmLabel, cancelLabel, onConfirm, onClose, onCancel, isLoading } =
    props;

  return (
    <Dialog
      isLoading={isLoading}
      id={id}
      onConfirm={onConfirm}
      onClose={onClose}
      onCancel={onCancel}
      title={dialogTitle}
      confirmLabel={confirmLabel}
      cancelLabel={cancelLabel}
    >
      {!!contentText?.length && (
        <>
          {contentText.map((text) => (
            <DialogContentText key={text} id={`${id}-description`} variant="body2" color="text.primary" mb={4}>
              {text}
            </DialogContentText>
          ))}
        </>
      )}

      {warningText && (
        <Typography variant="body2" color="primary">
          Warning: {warningText}
        </Typography>
      )}
    </Dialog>
  );
};
